module.exports = __webpack_public_path__ + "static/img/cf14688e4dd5ba352085ff19c884ed85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sol_icon2(2).png
// module id = uT4u
// module chunks = 1